import type { Option } from "@/components/form-inputs/StackedLabelKeyValueDropdown.vue";

export enum CustomFieldScope {
  PROJECT,
  DRAW,
}

export const ScopeDropdownOptions: Option[] = [
  {
    display: "Project",
    value: CustomFieldScope.PROJECT,
  },
  {
    display: "Draw",
    value: CustomFieldScope.DRAW,
  },
];
